import { TZDate } from '@date-fns/tz';
import { DEFAULT_DATE_FORMAT } from '@shared/constants';
import { format } from 'date-fns';

export const transformDateString = (value: string): string => {
  const tzDate = TZDate.tz('Europe/Zurich', value);
  return tzDate ? format(tzDate, DEFAULT_DATE_FORMAT) : '';
};

export const formatDate = (date: Date | undefined, dateFormat = DEFAULT_DATE_FORMAT): string => {
  return date ? format(date, dateFormat) : '';
};

export const formatToSwissIso = (date: Date | string): string => {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  const swissDate = new TZDate(date, 'Europe/Zurich');

  return format(swissDate, "yyyy-MM-dd'T'HH:mm:ss");
};
